import React from "react";
import { Button } from "@/components/Base/Button";
import { Icon } from "@/components/Common/Icon";
import { IconNames } from "@/types/v2";

interface ActivityFeedPaginationControlsProps {
  hasMore: boolean;
  loading: boolean;
  onLoadMore: () => void;
  totalLoaded?: number;
}

export const ActivityFeedPaginationControls: React.FC<
  ActivityFeedPaginationControlsProps
> = ({ hasMore, loading, onLoadMore, totalLoaded }) => {
  if (!hasMore && totalLoaded === 0) {
    return (
      <div className="py-8 text-center text-muted-foreground">
        No activities found matching your criteria.
      </div>
    );
  }

  if (!hasMore) {
    return (
      <div className="py-4 text-center text-sm text-muted-foreground">
        {totalLoaded
          ? `Showing all ${totalLoaded} activities`
          : "No more activities to load"}
      </div>
    );
  }

  return (
    <div className="flex justify-center py-4">
      <Button
        onClick={onLoadMore}
        loading={loading}
        variant="outline"
        size="sm"
        className="flex items-center gap-2"
        disabled={loading}
      >
        {loading ? (
          <>Loading more activities...</>
        ) : (
          <>
            <Icon name={IconNames.downArrow} className="h-4 w-4" />
            Load More Activities
          </>
        )}
      </Button>
    </div>
  );
};
